.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: none;
}

.container:focus {
  outline: 2px solid var(--aura-color-global-border-strong);
  outline-offset: 2px;
}

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

.blurLayer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  backdrop-filter: var(--particle-blur, none);
  -webkit-backdrop-filter: var(--particle-blur, none);
}

.backgroundLayer {
  position: absolute;
  inset: 0;
  z-index: -1;
}

.contentLayer {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
}
